module.exports = __webpack_public_path__ + "img/IMGP8617b.c8f71ff4.jpg";